// External Dependencies:
import axios from 'axios'
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import { doRequest } from 'utilities/request'
import { getStatesFromLatLng } from 'utilities/map-aus'

// Site:
export function setSiteLoaded() {
	return {
		type: 'SET_SITE_LOADED'
	}
}

export function addScript( value ) {
	return {
		type: 'ADD_SCRIPT',
		payload: value
	}
}

export function getScreenSize() {
	return {
		type: 'GET_SCREEN_SIZE'
	}
}

export function setOnLineStatus( value ) {
	return {
		type: 'SET_ONLINE_STATUS',
		payload: value
	}
}

export function setConnectionStatus( value ) {
	return {
		type: 'SET_CONNECTION_STATUS',
		payload: value
	}
}

export function getSiteData() {
	return function( dispatch, getState ) {
		doRequest( `${siteData.api_base_url}site-data/?v=${siteData.version}` )
			.then( json => {
				dispatch( receiveSiteData( json ) )
			} )
			.catch( error => {

			} )
	}
}

export function receiveSiteData( data ) {
	return {
		type: 'RECEIVE_SITE_DATA',
		payload: data
	}
}

// Menu:
export function openMenu() {
	return {
		type: 'OPEN_MENU'
	}
}

export function closeMenu() {
	return {
		type: 'CLOSE_MENU'
	}
}

export function setMenuOpenState( payload ) {
	return {
		type: 'SET_MENU_OPEN_STATE',
		payload
	}
}

export function requestMenuData() {
	return {
		type: 'REQUEST_MENU_DATA'
	}
}

export function getMenuData( username, password ) {
	return function( dispatch, getState ) {
		const { isLoadingMenu } = getState().site

		// Don't load the same thing simultaneously:
		if ( isLoadingMenu ) {
			return
		}

		dispatch( requestMenuData() )

		return doRequest( `${siteData.api_base_url}menu` )
			.then( json => {
				dispatch( receiveMenuData( json ) )
			} )
			.catch( error => {

			} )
	}
}

export function receiveMenuData( data ) {
	return {
		type: 'RECEIVE_MENU_DATA',
		payload: data
	}
}

// User:
export function requestCurrentPosition() {
	return function( dispatch, getState ) {
		if ( navigator.geolocation ) {
			navigator.geolocation.getCurrentPosition( ( pos ) => {
				const states = getStatesFromLatLng( {
					lat: pos.coords.latitude,
					lng: pos.coords.longitude
				} )

				dispatch( setUserLocation( {
					lat: pos.coords.latitude,
					lng: pos.coords.longitude,
					states
				} ) )
			} )
		}
	}
}

export function setUserLocation( location ) {
	const jsonValue = JSON.stringify( location )

	localStorage.setItem( 'user_location', jsonValue )

	return {
		type: 'SET_LOCATION',
		payload: location
	}
}

// Locations:
export function getLocationsData( username, password ) {
	return function( dispatch, getState ) {
		return doRequest( `${siteData.api_base_url}locations` )
			.then( json => {
				dispatch( receiveLocationsData( json ) )
			} )
			.catch( error => {

			} )
	}
}

export function receiveLocationsData( data ) {
	return {
		type: 'RECEIVE_LOCATIONS_DATA',
		payload: data
	}
}



// WEBPACK FOOTER //
// ./redux/actions/site.jsx